import { useEffect, useState } from 'react';
import Modal from 'modules/common/components/Modal';
import { discountItemTypeFilter, discountLifecycleStatus, PRODUCT_TYPE } from '../../constants';
import discountsStrings from '../../strings';
import {
  AdvancedFiltersDateRow,
  ModalBodyContent,
  ModalField,
  ModalInput,
  ModalLabel,
  ModalSelect,
} from '../../views/Discounts.style';

const STATUS_OPTIONS = [
  { id: discountLifecycleStatus.All, label: discountsStrings.statusAll , value: discountLifecycleStatus.All},
  { id: discountLifecycleStatus.Active, label: discountsStrings.statusActive , value: discountLifecycleStatus.Active},
  { id: discountLifecycleStatus.Scheduled, label: discountsStrings.statusScheduled , value: discountLifecycleStatus.Scheduled},
  { id: discountLifecycleStatus.Stopped, label: discountsStrings.statusStopped , value: discountLifecycleStatus.Stopped},
  { id: discountLifecycleStatus.Completed, label: discountsStrings.statusCompleted , value: discountLifecycleStatus.Completed},
];

export type AdvancedDiscountFilters = {
  status: number;
  itemType: number;
  startDate: string;
  endDate: string;
};
interface AdvancedFiltersModalProps {
  isOpen: boolean;
  filters: AdvancedDiscountFilters;
  onClose: () => void;
  onApply: (filters: AdvancedDiscountFilters) => void;
}

const AdvancedFiltersModal = ({ isOpen, filters, onClose, onApply }: AdvancedFiltersModalProps) => {
  const [status, setStatus] = useState(filters.status);
  const [itemType, setItemType] = useState(filters.itemType);
  const [startDate, setStartDate] = useState(filters.startDate);
  const [endDate, setEndDate] = useState(filters.endDate);

  useEffect(() => {
    if (!isOpen) return;
    setStatus(filters.status);
    setItemType(filters.itemType);
    setStartDate(filters.startDate);
    setEndDate(filters.endDate);
  }, [filters, isOpen]);

  const handleClear = () => {
    setStatus(discountLifecycleStatus.All);
    setItemType(discountItemTypeFilter.All);
    setStartDate('');
    setEndDate('');
  };

  const handleApply = () => {
    onApply({ status, itemType, startDate, endDate });
    onClose();
  };

  return (
    <Modal
      toggle={isOpen}
      title={discountsStrings.advancedFiltersTitle}
      onClose={onClose}
      onCancelHandler={handleClear}
      cancelActionLabel={discountsStrings.clearBtn}
      onConfirmHandler={handleApply}
      confirmActionLabel={discountsStrings.applyBtn}
      closeOnClickOutside={false}
      size="md"
    >
      <ModalBodyContent>
        <ModalField>
          <ModalSelect value={status} onChange={event => setStatus(Number(event.target.value))}>
            <option value={discountLifecycleStatus.All}>{discountsStrings.statusPlaceholder}</option>
            {STATUS_OPTIONS.filter(option => option.id !== discountLifecycleStatus.All).map(option => (
              <option key={option.id} value={option.value}>
                {option.label}
              </option>
            ))}
          </ModalSelect>
        </ModalField>

        <ModalField>
          <ModalSelect value={itemType} onChange={event => setItemType(Number(event.target.value))}>
            <option value={discountItemTypeFilter.All}>{discountsStrings.itemTypeLabel}</option>
            <option value={PRODUCT_TYPE.Product}>{discountsStrings.itemTypeProduct}</option>
            <option value={PRODUCT_TYPE.Bundle}>{discountsStrings.itemTypeBundle}</option>
          </ModalSelect>
        </ModalField>

        <AdvancedFiltersDateRow>
          <ModalField>
            <ModalLabel>{discountsStrings.fromLabel}</ModalLabel>
            <ModalInput
              type="date"
              value={startDate}
              onChange={event => setStartDate(event.target.value)}
            />
          </ModalField>
          <ModalField>
            <ModalLabel>{discountsStrings.toLabel}</ModalLabel>
            <ModalInput
              type="date"
              value={endDate}
              onChange={event => setEndDate(event.target.value)}
            />
          </ModalField>
        </AdvancedFiltersDateRow>
      </ModalBodyContent>
    </Modal>
  );
};

export default AdvancedFiltersModal;
